import {useMutation, useQuery} from "@tanstack/react-query";
import type {Club, ClubForm} from '@iziping/common';
import { apiClient } from '@iziping/common';
import { ENDPOINTS, QUERY_CACHE } from '@/model/endpoints';
import type {ApiError} from '@iziping/common';

export const useGetClub = (id?: number) => {
    return useQuery<Club>({
        queryKey: [QUERY_CACHE.CLUB],
        queryFn: async () => {
            if (!id) throw new Error("ID manquant");
            const response = await apiClient.get<Club>(ENDPOINTS.club(id));
            return response.data;
        },
        enabled: !!id
    })
};

export const useGetClubs = () => {
    return useQuery<Club[], ApiError>({
        queryKey: [QUERY_CACHE.CLUBS],
        queryFn: async () => {
            const response = await apiClient.get<Club[]>(`${ENDPOINTS.clubs}`);
            return response.data;
        },
        enabled: true,
    });
};

export const useSaveClub = () => {
    return useMutation<Club, ApiError, Club|ClubForm>({
        mutationKey: [QUERY_CACHE.CREATE_HEAT_REGISTRATION],
        mutationFn:
            async (payload) => {
                if ('id' in payload) {
                    // Édition
                    const response = await apiClient.put<Club>(`${ENDPOINTS.club(payload.id)}`, payload);
                    return response.data;
                } else {
                    // Création
                    const response = await apiClient.post<Club>(`${ENDPOINTS.clubs}`, payload);
                    return response.data;
                }
            }
    })
};


